<script lang="ts">
  import { cn } from '@shared/lib';

  export let classes = '';
</script>

<span
  class="{cn(
    'hover:decoration-default-500 inline-block text-base underline decoration-transparent decoration-1 underline-offset-[6px] transition-[text-decoration-color] duration-300 before:bottom-0',
    classes,
  )}"
>
  <slot />
</span>
